(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sheetforge", [], factory);
	else if(typeof exports === 'object')
		exports["sheetforge"] = factory();
	else
		root["sheetforge"] = factory();
})(global, function() {
return 